import getTranslate from '/expert/mobile/getTranslate.js';
import setTranslate from '/expert/mobile/setTranslate.js';
import minTranslate from '/expert/mobile/minTranslate.js';
import maxTranslate from '/expert/mobile/maxTranslate.js';
import translateTo from '/expert/mobile/translateTo.js';

export default {
  getTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
};
